// extracted by mini-css-extract-plugin
export default {"p":"GenericWarning_p__j-pGS","container":"GenericWarning_container__PvM+Q"};